<template>
  <div class="sort-results-holder" :class="(orderByType !== orderBy) ? 'faded' : ''">
    <div class="sort-selection" @click="handleSortClick">
      <div class="sort-selector">
        <div class="sort-selected" v-if="orderByType === orderBy "></div>
      </div>
      <div class="sort-label">{{ label }}</div>
    </div>
    <div class="sort-order" @click="handleSortOrderClick" :class="(orderByType !== orderBy) ? 'disable' : ''">
      <div class="order-icon">
        <div class="order-icon-holder" :class="(descending) ? 'icon-slide' : ''">
          <img :src="require('@/assets/svg/SVG/order_by_' + orderByType + '.svg')">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapStores, storeToRefs } from 'pinia/dist/pinia';
import { useRMTStore } from '@/store/RMTStore';

export default {
  name: 'SortResults',
  props: [
      'label',
      'orderByType',
      'icon'
  ],
  data () {
    return {
      descending: false
    };
  },
  setup () {
    const RMTStore = useRMTStore();
    const {orderBy, orderDescending} = storeToRefs(RMTStore);
    return {
      RMTStore, orderBy, orderDescending
    };
  },
  computed: {
    ...mapStores(useRMTStore),
  },
  methods: {
    handleSortClick () {
      const RMTStore = useRMTStore();
      RMTStore.setSortOrderBy(this.$props.orderByType);
      RMTStore.setSortDescending(this.descending);
      RMTStore.filterResources();
    },
    handleSortOrderClick () {
      const RMTStore = useRMTStore();
      if (RMTStore.orderBy !== this.$props.orderByType) { return; }
      this.descending = !this.descending;
      RMTStore.setSortDescending(this.descending);
      RMTStore.filterResources();
    }
  }
};
</script>

<style scoped>
.sort-results-holder {
  display: flex;
  justify-content: center;
  align-items: center;
  transition: .2s opacity;
}

.sort-results-holder:hover {
  opacity: 1;
}

.faded {
  opacity: .5;
}

.sort-selection {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 25px;
  border-bottom-left-radius: 25px;
  background-color: #e8e8e8;
  gap: 5px;
  padding: 5px 10px;
  height: 30px;
  cursor: pointer;
}

.sort-order {
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
  background-color: #d3d3d3;
  padding: 5px 5px;
  width: 40px;
  height: 30px;
  font-size: .80em;
  cursor: pointer;
}

.sort-order:hover {
  background-color: darkgray;
}

.disable {
  pointer-events: none;
}

.sort-selector {
  width: 15px;
  height: 15px;
  border: 1.5px solid black;
  border-radius: 7px;
  display: flex;
  justify-content: center;
  align-items: center;

}

.sort-selected {
  width: 8px;
  height: 8px;
  background-color: black;
  border-radius: 8px;
}

.sort-label {
  font-size: .80em;
  font-weight: 600;
}

.order-icon {
  width: 26px;
  height: 26px;
  overflow: hidden;
}

.order-icon-holder {
  height: 26px;
  width: 52px;
  transform: translateX(0);
  transition: .2s transform;
}

.icon-slide {
  transform: translateX(-26px);
}

</style>